import { fetchAndStoreRoastingEvents } from '$lib/dataLoader.js';

export async function load({ parent }) {
  await parent();
  fetchAndStoreRoastingEvents();
  return {};
}
